import { LitElement as u, unsafeCSS as c } from "lit";
import { property as s, state as d } from "lit/decorators.js";
import f from "../../shared/reset.style.css.js";
import { booleanType as n } from "../../utils/property-types.js";
import m from "./alert.style.css.js";
import { alertTemplate as y } from "./alert.template.js";
var g = Object.defineProperty, t = (p, o, r, a) => {
  for (var i = void 0, l = p.length - 1, h; l >= 0; l--)
    (h = p[l]) && (i = h(o, r, i) || i);
  return i && g(o, r, i), i;
};
class e extends u {
  constructor() {
    super(...arguments), this.state = "info", this.size = "md", this.message = void 0, this.titleText = void 0, this.description = void 0, this.buttonLabel = "Label", this.showMoreLabel = "Mostrar més", this.showLessLabel = "Mostrar menys", this.hasCloseIcon = !1, this.hasButton = !1, this.fullWidth = !1, this.buttonBottom = !1, this.expanded = !1, this.isOverflowing = !1, this._stateIcon = "info";
  }
  static get styles() {
    return [c(f), c(m)];
  }
  _handleButtonClick() {
    this.dispatchEvent(new CustomEvent("onButtonClick", { bubbles: !0, composed: !0 }));
  }
  _handleClose() {
    this.dispatchEvent(new CustomEvent("onClose", { bubbles: !0, composed: !0 }));
  }
  updated(o) {
    o.has("state") && this.setStateIcon(), o.has("message") && queueMicrotask(() => {
      this.titleText = this.message;
    });
  }
  async firstUpdated() {
    await this.updateComplete, setTimeout(() => {
      const o = this.renderRoot.querySelector(".dss-alert__text"), r = this._isTextTruncated(o), a = this.renderRoot.querySelector(".dss-alert__description"), i = this._isTextTruncated(a);
      this.isOverflowing = r || i;
    }, 0);
  }
  _isTextTruncated(o) {
    if (!o) return !1;
    const { scrollHeight: r, clientHeight: a } = o;
    return r > a;
  }
  setStateIcon() {
    switch (this.state) {
      case "error":
        this._stateIcon = "cancel";
        break;
      case "warning":
        this._stateIcon = "report";
        break;
      case "success":
        this._stateIcon = "check_circle";
        break;
      default:
        this._stateIcon = "info";
    }
  }
  _getIconSize() {
    return this.size === "lg" ? "md" : "sm";
  }
  toggleExpand() {
    this.expanded = !this.expanded;
  }
  render() {
    return y(this);
  }
}
t([
  s({ type: String })
], e.prototype, "state");
t([
  s({ type: String })
], e.prototype, "size");
t([
  s({ type: String })
], e.prototype, "message");
t([
  s({ type: String })
], e.prototype, "titleText");
t([
  s({ type: String })
], e.prototype, "description");
t([
  s({ type: String })
], e.prototype, "buttonLabel");
t([
  s({ type: String })
], e.prototype, "showMoreLabel");
t([
  s({ type: String })
], e.prototype, "showLessLabel");
t([
  s(n)
], e.prototype, "hasCloseIcon");
t([
  s(n)
], e.prototype, "hasButton");
t([
  s(n)
], e.prototype, "fullWidth");
t([
  s(n)
], e.prototype, "buttonBottom");
t([
  d(n)
], e.prototype, "expanded");
t([
  d(n)
], e.prototype, "isOverflowing");
export {
  e as Alert
};
//# sourceMappingURL=alert.js.map
